import AIToolsDashboard from './AIToolsDashboard';

function App() {
  return (
    <div className="App">
      <AIToolsDashboard />
    </div>
  );
}

export default App;